import { render, staticRenderFns } from "./CompetitionBenefitBox.vue?vue&type=template&id=022d5d7f&scoped=true&"
import script from "./CompetitionBenefitBox.vue?vue&type=script&lang=js&"
export * from "./CompetitionBenefitBox.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionBenefitBox.vue?vue&type=style&index=0&id=022d5d7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d5d7f",
  null
  
)

export default component.exports